import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import React, { useEffect, useMemo } from "react";
import { Constants, useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { DatasetComponent, GridComponent, VisualMapComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
//#region src/modules/Stats/shared/ActivityTypeTagsHorizontalBarChart.tsx
echarts.use([
	DatasetComponent,
	GridComponent,
	VisualMapComponent,
	BarChart,
	CanvasRenderer
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function calculateContainerHeight(numberOfBars) {
	return numberOfBars * 30 + 180;
}
function ActivityTypeTagsHorizontalBarChart({ activityTypeTags }) {
	const { isDarkMode } = useAtalayaContext();
	const containerRef = React.useRef(null);
	const containerHeight = useMemo(() => calculateContainerHeight(activityTypeTags.length), [activityTypeTags.length]);
	useEffect(() => {
		if (!containerRef.current) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const option = {
			grid: { containLabel: true },
			series: [{
				data: activityTypeTags.map(({ count }) => count),
				itemStyle: { color: ({ dataIndex }) => activityTypeTags[dataIndex].color || Constants.Color[isDarkMode ? "Dark" : "Light"].Info },
				label: {
					formatter: "{c}",
					position: "right",
					show: true
				},
				type: "bar"
			}],
			title: {
				left: "center",
				text: "Activity Type Tags"
			},
			xAxis: { type: "value" },
			yAxis: {
				data: activityTypeTags.map(({ title }) => title),
				type: "category"
			}
		};
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		activityTypeTags,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: { height: containerHeight }
	});
}
//#endregion
export { ActivityTypeTagsHorizontalBarChart };

//# sourceMappingURL=ActivityTypeTagsHorizontalBarChart.js.map